import type { ErrorInfo, ReactNode } from 'react';
import { TopoloAppErrorBoundary } from '@topolo-io/app-shell';
import { reportClientError } from '../lib/client-telemetry';

interface Props {
  children: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

export function ErrorBoundary({ children, onError }: Props) {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    reportClientError('Error caught by boundary', error, errorInfo);
    onError?.(error, errorInfo);
  };

  return (
    <TopoloAppErrorBoundary appName='CRM' onError={handleError} onReset={() => undefined}>
      {children}
    </TopoloAppErrorBoundary>
  );
}
